import * as React from 'react';
import { LogBox } from 'react-native';
import { featureFlags } from 'react-native-screens';

import 'react-native-get-random-values';
import 'expo-dev-client';
import '@expo/metro-runtime';
import { Loaded } from 'components/App/Loaded';
import * as SplashScreen from 'expo-splash-screen';
import { init as sentryInit, wrap as sentryWrap } from '@sentry/react-native';
import { version as appVersion } from './version.json';
import * as Font from 'expo-font';
import {
  FontFamilyMedium,
  FontFamilyMonoSemibold,
  FontFamilyRegular,
  FontFamilySemibold,
} from 'lib/theme';

import 'components/App/Startup';

// Enables flex:1 to work correctly inside formSheet presentations (RN >= 0.82 required)
featureFlags.experiment.synchronousScreenUpdatesEnabled = true;

if (!__DEV__) {
  sentryInit({
    dsn: 'https://50eadce300543f6b933d1fb2c8202678@o4507142260719616.ingest.de.sentry.io/4507142261964880',
    release: `uk.riskbase.app@${appVersion}`,
    environment:
      process.env.APP_VARIANT === 'development' ? 'development' : 'production',
    debug: __DEV__,
  });
}

LogBox.ignoreLogs([
  "[react-native-gesture-handler] Seems like you're using an old API with gesture components, check out new Gestures system!",
  'VirtualizedLists should never be nested inside plain ScrollViews with the same orientation because it can break windowing and other functionality - use another VirtualizedList-backed container instead.',
]);

// if (__DEV__) {
//   const IGNORED_LOGS = ['Warning: React does not recognize the '];
//   const withoutIgnored =
//     (
//       logger:
//         | typeof console.log
//         | typeof console.info
//         | typeof console.warn
//         | typeof console.error,
//     ) =>
//     (...args: string[]) => {
//       const output = args.join(' ');
//       if (!IGNORED_LOGS.some((log) => output.includes(log))) {
//         logger(...args);
//       } else {
//         logger('Log ignored');
//       }
//     };
//   console.error = withoutIgnored(console.error);
//   // console.log = withoutIgnored(console.log);
//   // console.info = withoutIgnored(console.info);
//   // console.warn = withoutIgnored(console.warn);
// }

// Keep the splash screen visible while we fetch resources
SplashScreen.setOptions({
  duration: 400,
  fade: true,
});
SplashScreen.preventAutoHideAsync();

const FontRegular = require('assets/fonts/SFProTextRegular.ttf');
const FontMedium = require('assets/fonts/SFProTextMedium.ttf');
const FontBold = require('assets/fonts/SFProTextSemibold.ttf');
const FontMonoBold = require('assets/fonts/SFMonoSemibold.otf');

const AppUnwrapped = () => {
  const [fontsLoaded] = Font.useFonts({
    [FontFamilyRegular]: FontRegular,
    [FontFamilyMedium]: FontMedium,
    [FontFamilySemibold]: FontBold,
    [FontFamilyMonoSemibold]: FontMonoBold,
  });

  const handleLayoutRootView = React.useCallback(() => {
    SplashScreen.hide();
  }, []);

  if (!fontsLoaded) {
    return null;
  }

  return <Loaded onReady={handleLayoutRootView} />;
};

export const App = __DEV__ ? AppUnwrapped : sentryWrap(AppUnwrapped);
